( function () {
	'use strict';
	/* eslint-disable max-params */
	function Authenticate ( $location, logger, authService, $routeParams, Session, moment, licensesFactory, _, $ ) {
		var self = this;

		self.loading = false;

		function checkLicense ( licenses ) {
			var showErrorMessage = true;

			if ( licenses.length > 0 ) {
				var license = _.find( _.filter( licenses, { 'LicenseTypeId' : 1000 } ), function ( item ) {
					return moment().isBefore( item.ExpireDate );
				} );

				if ( license ) {
					showErrorMessage = false;
				}
			}

			if ( showErrorMessage ) {
				authService.killSession( true );
				$location.url( '/login?error=invalid_license' ).replace();
			} else {
				var requestedUrl = Session.getCredentials().requestedUrl;

				$location.url( requestedUrl ).replace();
			}
		}

		function makeUrl ( routeParams ) {
			var path   = routeParams.url;
			var params = _.omit( routeParams, [ 'url', 'token' ] );

			var url = path + '?' + $.param( params );

			return url;
		}

		function authenticateToken () {
			// get the credentials using token
			self.loading = true;
			authService.getCredentialsByToken( $routeParams.token )
			.then( function () {
				// make the requested url
				var requestedUrl = makeUrl( $routeParams );

				Session.updateCredentials( { 'requestedUrl' : requestedUrl } );

				// Set user info for ZenDesk
				if ( typeof window.setUserInfoForZenDesk !== 'undefined' ) {
					var user = Session.getCredentials();

					window.setUserInfoForZenDesk( user.FirstName + ' ' + user.LastName, user.EmailAddress );
				}

				// get user licenses
				licensesFactory.getUserLicenses().then( function ( licenses ) {
					checkLicense( licenses );
					self.loading = false;
				} );
			}, function () {
				logger.error( 'Unable to fetch.', ''  );
				self.loading = false;
				$location.url( '/' ).replace();
			} );
		}

		function activate () {
			logger.info( 'Authenticateing...' );
			authenticateToken();
		}

		activate();
	}

	angular
		.module( 'app.login' )
		.controller( 'Authenticate', Authenticate );

	Authenticate.$inject = [ '$location', 'logger', 'authService', '$routeParams', 'Session', 'moment', 'licensesFactory', '_', '$' ];
} )( );
